module.exports = __webpack_public_path__ + "static/img/kawachi_01.322395c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/kawachi_01.jpg
// module id = Fp1q
// module chunks = 0